
import api from '@/api';

const namespaced = true;

const state = {
  makerDomains: [],
};

const mutations = {
  SET_MAKER_DOMAINS(state, domains) {
    state.makerDomains = domains;
  },
  ADD_MAKER_DOMAIN(state, domain) {
    state.makerDomains.push(domain);
  },
  SAVE_DOMAIN(state, saveDomain) {
    let index = -1;
    state.makerDomains.forEach((domain, i) => {
      if (saveDomain.id === domain.id) {
        index = i;
      }
    });
    state.makerDomains.splice(index, 1, saveDomain);
  },
  DELETE_DOMAIN(state, deleteDomain) {
    let index = -1;
    state.makerDomains.forEach((domain, i) => {
      if (deleteDomain.id === domain.id) {
        index = i;
      }
    });
    state.makerDomains.splice(index, 1);
  },
};

const actions = {
  async fetchMakerDomains({ commit, dispatch, rootState }, makerId = null) {
    const domains = await dispatch(`fetchDomainsForMaker`, makerId || rootState[`model/client`].company.id);

    commit(`SET_MAKER_DOMAINS`, domains);

    return domains;
  },
  async fetchDomainsForMaker(store, makerId) {
    const { data: domains } = await api.get(`/domains/maker/${makerId}`);

    return domains;
  },
  async addDomain({ commit, rootState }, { id, name, makerId }) {
    makerId = makerId || rootState[`model/client`].company.id;
    const { data: newDomain } = await api.post(`/domains/maker/${makerId}`, { id, name });
    commit(`ADD_MAKER_DOMAIN`, newDomain);

    return newDomain;
  },
  async saveDomain({ commit }, { id, name, makerId }) {
    try {
      const { data: newDomain } = await api.put(`/domains/${id}`, { id, name, makerId });
      commit(`SAVE_DOMAIN`, newDomain);

      return newDomain;
    } catch (e) {} // eslint-disable-line

    return null;
  },
  async deleteDomain({ commit }, domain) {
    try {
      await api.delete(`/domains/${domain.id}`, domain);
      commit(`DELETE_DOMAIN`, domain);
    } catch (e) {} // eslint-disable-line
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
